import { render, staticRenderFns } from "./ResourceField.vue?vue&type=template&id=4e4a03fc&lang=pug&"
import script from "./ResourceField.vue?vue&type=script&lang=js&"
export * from "./ResourceField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports